import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init () {
    const toggleBtn = document.querySelector('[data-tag-filters-toggle]')
    const filterList = document.querySelector('[data-tag-filters-list]')
    const filterBtns = document.querySelectorAll('[data-filter]')
    const items = document.querySelectorAll('[data-filters]')

    let activeFilter = null
    let state = false

    toggleBtn.addEventListener('click', () => {
      state = !state
      filterList.classList.toggle('!hidden', !state)
    })

    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const { filter } = btn.dataset

        if (activeFilter === filter) {
          activeFilter = null
          items.forEach(item => {
            item.classList.remove('hidden')
          })
          btn.style.removeProperty('color')
          btn.style.removeProperty('background-color')
          btn.style.removeProperty('border')
          return
        }

        activeFilter = filter
        filterBtns.forEach(_btn => {
          if (_btn !== btn) {
            _btn.style.removeProperty('color')
            _btn.style.removeProperty('background-color')
            _btn.style.removeProperty('border')
          } else {
            _btn.style.color = 'white'
            _btn.style.backgroundColor = 'var(--theme)'
            _btn.style.border = 'none'
          }
        })

        items.forEach(item => {
          if (activeFilter === 'all') {
            item.classList.remove('hidden')
            return
          }

          if (item.dataset.filters.includes(activeFilter)) {
            item.classList.remove('hidden')
          } else {
            item.classList.add('hidden')
          }
        })
      })
    })
  }
}
